import React from "react";
import TableHeadingChip from "../TableHeadingChip";
import { Disclosure } from "@headlessui/react";
import TableGroup from './TableGroup'
import TableRow from "../TableRow";
const TablePW = () => {
  return (
    <div className="w-full pt-8 overflow-x-auto max-w-full  custom-dashboard-table-container">
      <div className="w-full mx-auto bg-white rounded-2xl  flex flex-col custom-dashboard-table">
        <div className="flex -mb-8  ml-8">
          <div className="table-left-content"></div>
          
          <TableHeadingChip text="Utility Network" />
          <TableHeadingChip text={<>Field Data<br/>Collection</>} />
          <TableHeadingChip text={<>Data Health<br></br>Check</>}/>
          <TableHeadingChip text={<>AGOL<br></br>Launch Kit</>}/>

          {/* <TableHeadingChip text="ArcGIS Utility Network" />
          <TableHeadingChip text={<>Field Operations<br/>Launch Kit</>} />
          <TableHeadingChip text={<>ArcGIS Data<br></br>Health Checks</>}/>
          <TableHeadingChip text={<>AGOL <br></br>Launch Kit</>}/> */}

        </div>

        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup
              title="Daily Use"
              isOpen={open}
              isFirst={true}
            >
              <TableRow
                content={{
                  title: "Level of technical knowledge required to operate",
                  values: [ "Advance", "Medium", "Medium", "Medium"],
                }}
              />
                      
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup
              title="Population pre-requisites"
              isOpen={open}
            >
              <TableRow
              notbold={true}
                content={{
                  title: "My organization's population size",
                  values: ["Any size", "Any size",  "Any size", "Any size"],
                  // values: ["typically larger than 15K", "Any size",  "Any size", "Any size"],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="General" isOpen={open}>
            {/* <TableGroup title="Foundational GIS Needs" isOpen={open}> */}
              <TableRow
                content={{
                  title:
                    "Become self-sufficient and develop professional skill sets to use ArcGIS platform",
                  values: [false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Introduce ArcGIS to my organization and jumpstart its use",
                  values: [false, false, false, true],
                }}
              />
              <TableRow
                content={{
                  title: "Looking to implement field data collection apps",
                  values: [false, false, false, true],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Optimizing Field Efficiency" isOpen={open}>
              <TableRow
                content={{
                  title:
                    "Eliminate or reduce the reliance on paper based processes",
                  values: [false, true, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Expand the use of field data collection apps to reduce errors, boost productivity and save $$",  // new added row
                  values: [false, true, false, false],
                }}
              />
                  <TableRow
                    content={{
                      title:
                        "Get access to most accurate, reliable and real-time field operation data",  //this row is moved up from next
                        // "Access to most accurate, reliable and real-time field operation data",
                        values: [false, true, false, false],
                    }}
                  />
              <TableRow
                content={{
                  title: "Monitor field worker activities in real time",
                  values: [false, true, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Ability to prioritize work and dispatch resources with location awareness",
                    // "Ability to prioritize work and dispatch resources through a data driven approach",
                  vvalues: [false, true, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Complete spatial awareness about existing assets on/below ground while performing inspections",
                    values: [false, true, false, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Quality of Data" isOpen={open}>
            {/* <TableGroup title="Data Quality &amp; Management" isOpen={open}> */}
              <TableRow
                content={{
                  title:
                    "The quality of data in currently in use for field operations",
                  values: [false, true, true, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Maintaining the quality of the data with consistent and repeatable data review processes for all field operation activities",
                    // "Maintain the quality of the data with consistent and repeatable data review processes",
                  values: [false, true, true, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Track, manage and monitor the status of organization's data at all times",
                  values: [false, false, true, false],
                }}
              />
            </TableGroup>
          )}
        </Disclosure>
        <Disclosure defaultOpen={true}>
          {({ open }) => (
            <TableGroup title="Increasing Operational Awareness of Utility Assets" isOpen={open}>
            {/* <TableGroup title="Utility Management" isOpen={open}> */}
              <TableRow
                content={{
                  title:
                    "Implement network rules to model real world operations",
                    // "Implement custom network rules to model real world operations.",
                  values: [true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title: "Ability to model features and assets of any size",
                  values: [true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Temporally visualize resources in 3D for user solutions across the ArcGIS platform",
                  values: [true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                    "Use analysis and tracing tools to perform large variety of analytics workflows", //new added row
                  values: [true, false, false, false],
                }}
              />
              <TableRow
                content={{
                  title:
                  "Get a full operational view of how dynamic devices of utilities are configured",
                  // "Full operational view of how dynamic devices of utilities are configured",
                  values: [true, false, false, false],
                }}
              />
                <TableRow
                  content={{
                    title:
                      "Track how gas, water and electricity flow through the network",  //moved to down
                    values: [true, false, false, false],
                  }}
                />
            </TableGroup>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default TablePW;
